import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Challenge } from 'src/app/models/challenge';
import { UserService } from '../user.service';

@Injectable({
  providedIn: 'root',
})
export class UserChallengesResolverService  {
  constructor(private _userService: UserService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Challenge[]> {
    return this._userService.getUserChallenges();
  }
}
